import { render } from "./TextBox.vue?vue&type=template&id=3881bf74&scoped=true"
import script from "./TextBox.vue?vue&type=script&lang=ts"
export * from "./TextBox.vue?vue&type=script&lang=ts"

import "./TextBox.vue?vue&type=style&index=0&id=3881bf74&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3881bf74"

export default script